import { render, staticRenderFns } from "./NewOfferWidget.vue?vue&type=template&id=5243ff9e&scoped=true"
import script from "./NewOfferWidget.vue?vue&type=script&lang=ts"
export * from "./NewOfferWidget.vue?vue&type=script&lang=ts"
import style0 from "./NewOfferWidget.vue?vue&type=style&index=0&id=5243ff9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5243ff9e",
  null
  
)

export default component.exports